import * as S from './styles';

export type LinearLoaderProps = {
  indeterminate?: boolean;
};

export const LinearLoader = ({ indeterminate = true }: LinearLoaderProps) => (
  <S.Loader indeterminate={indeterminate} aria-label="loading..." />
);
